<template>
  <div class="handDetails">
    <!-- 二手详情 -->
    <div class="topContent">
      <div class="contentBox">
        <!-- 如果是二手 -->
        <div class="handMoney"  >
          <span class="x_m">￥<em>{{thread.options.trade_price}}</em></span><span class="y_m" v-if="thread.options.yuanjia">￥<em>{{thread.options.yuanjia}}</em></span>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- 如果是二手 -->
      <div class="item hand green" @click="intoDownlyq">
        <div class="innerLeft">发二手</div>
        <div class="innerRight">拨打电话</div>
      </div>
    </div>
    <!-- 下载 -->
          <div class="descMask" v-show="intoDownloadLyq">
              <div class="maskBox">
                  <div class="code">
                      <img src="@/assets/imgs/db.jpg">
                  </div>
                  <div class="descTxt">邻友圈App或微信扫一扫参与互动</div>
                  <div class="closeR" @click="closefoot"><img  src="@/assets/imgs/c2.png"></div>
              </div>
          </div>
  </div>
</template>
<script>
export default {
  props:['thread'],
  data() {
    return {
      intoDownloadLyq:false,
    };
  },
  mounted(){
    console.log(this.thread)
  },
  methods: {
    intoDownlyq(){
          this.intoDownloadLyq = true
    },
    closefoot(){
          this.intoDownloadLyq = false
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/index.less";
.handDetails {
  .topContent {
    .contentBox {
      .handMoney {
        margin: 20px 0;
        .x_m {
          color: #ff4c45;
          font-size: 12px;
          display: inline-block;
          margin-right: 10px;
          em {
            font-size: 18px;
            font-style: normal;
          }
        }
        .y_m {
          text-decoration: line-through;
          color: #999;
          font-size: 12px;
          display: inline-block;
          em {
            font-style: normal;
          }
        }
      }
    }
  }
  .footer{
          .item{
            cursor: pointer;
            z-index: 99;
            position: fixed;
            width:100% ;
            max-width: 752px;
            bottom: 0;
            height: 50px;
            line-height:50px ;
            color:#333;
            font-size: 16px;
          }
          .hand{
            display: inline-flex;
            text-align: center;
            .innerLeft{
              color: #333;
              width: 30%;
              background-color: #f2f2f2;
            }
            .innerRight{
              color: #fff;
              width: 70%;
              background-color: #e44100;
            }
          }
  }
  .descMask{
			position: fixed;
			top:0;
			left:0;
			width:100%;
			height: 100%;
			background: rgba(0,0,0,.7);
			z-index: 9999;
			.maskBox{
				width:40%;
				padding:25px 35px;
				box-sizing: border-box;
				background:#fff;
				border-radius:5px;
				position: absolute;
				top: 40%;
				left: 50%;
				transform: translate(-50%, -40%);
				.close{
                    cursor: pointer;
					position: absolute;
					bottom:-36px;
					left:50%;
					width:20px;
					height: 20px;
					margin-left:-26px;
				}
				.txt{
					text-align: center;
					margin:0 0 20px 0;
				}
				.desc{
					font-size:15px;
					margin:0 0 10px 0;
					padding:0 0 0 30px;
					background:url("~@/assets/imgs/ts.png") no-repeat left center;
					background-size:10px 10px;
				}
                .wImg{
                    width: 200px;
                    margin: 20px 0;
                    text-align: center;
                    margin: 0 auto;
                    img{
                        display: block;
                        width: 200px;
                        height: 200px;
                        
                    }
                }
                .title{
                    margin:0 0 20px 0;
                    text-align: center;
                }
                .iknow{
                    color: #55aa7f;
                    cursor: pointer;
                    text-align: center;
                }
                .code{
                    width: 200px;
                    margin: 0 auto;
                    img{
                        width: 200px;
                        height: 200px;
                    }
                }
                .descTxt{
                    margin: 10p 0;
                    font-size: 18px;
                    text-align: center;
                }
                .closeR{
                    position: absolute;
                    right: 10px;
                    top: 10px;
                    img{
                        display: block;
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
			}
		}
}
</style>


// WEBPACK FOOTER //
// src/components/handdetail/handdetail.vue